module.exports = __webpack_public_path__ + "img/10.0f660e27.jpg";